import {URL_PATIENT_PGD, URL_PATIENT_PGD_SHOW} from "../../../routes/routes-constants"
import {Tables} from "features/common/pgd-pg-common/Table"



export const Table = () => {
  return <Tables pgType="pgd" urlPatient={URL_PATIENT_PGD} urlShowPatient={URL_PATIENT_PGD_SHOW}/>
}